export class TaxSettingsDefaults {
  tax_zone_id: number | null = null;
  taxability: TaxabilityType | null = null;
  reason: string | null = null;

  constructor(params: Partial<TaxSettingsDefaults> = {}) {
    Object.assign(this, params);
  }

  static fromSettings(taxSettings: Partial<TaxSettingsData> = {}) {
    return new TaxSettingsDefaults({
      tax_zone_id: taxSettings.tax_zone_id,
      taxability: taxSettings.taxability,
      reason: taxSettings.reason
    });
  }
}
export type TaxSettingsContextTypes = "Customer" | "Address" | "Quote";

export type TaxabilityType =
  | "taxable"
  | "nontaxable"
  | "tax_exempt"
  | "not_set";

export type TaxSettingsConfig = TaxSettingsData & {
  useDefaultSettings: boolean;
};

export type TaxSettingsFormData = {
  id: number | null;
  taxability: TaxabilityType | null;
  reason: string | null;
  tax_zone_id: number | null;
};

export type TaxSettingsData = {
  id: number | null;
  taxability: TaxabilityType;
  taxable: boolean;
  tax_zone_formatted_name: string;
  tax_zone_id: number | null;
  tax_rate: string;
  reason: string | null;
  source: string;
};

// Hide the tax exempt for Company Settings
export function getTaxabilityOptions(contextType?: TaxSettingsContextTypes) {
  const options = [
    {
      label: "Taxable",
      value: "taxable"
    },
    {
      label: "Nontaxable",
      value: "nontaxable"
    }
  ];
  if (
    contextType === "Customer" ||
    contextType === "Address" ||
    contextType === "Quote"
  ) {
    options.push({
      label: "Tax-Exempt",
      value: "tax_exempt"
    });
  }
  return options;
}

export function taxabilityOneLineDisplay(taxSetting?: TaxSettingsData | null) {
  if (!taxSetting) return "None Set";
  if (taxSetting.taxable) {
    if (taxSetting.tax_zone_formatted_name) {
      return taxSetting.tax_zone_formatted_name;
    }
  }
  return friendlyTaxabilityDisplay(taxSetting.taxability);
}

export function hasMissingTaxZone(taxSetting?: TaxSettingsData | null) {
  if (!taxSetting) return true;
  return (
    taxSetting.taxability === "taxable" &&
    !taxSetting.tax_zone_id &&
    !taxSetting.tax_zone_formatted_name
  );
}

export function friendlyTaxabilityDisplay(taxability?: TaxabilityType) {
  if (taxability === "taxable") return "Taxable";
  if (taxability === "nontaxable") return "Nontaxable";
  if (taxability === "tax_exempt") return "Tax-Exempt";
  return "Not Set";
}
